import { createSelector } from '@ngrx/store';
import { getTotalTimeState } from '../store/store.selectors';
import { TotalTimeStateInterface, selectAll } from './totalTime.state';

export const getAllTotalTimeEntry = createSelector(
  getTotalTimeState,
  (state: TotalTimeStateInterface) => selectAll(state)
);
